<template>
	<div class="parte" :class="{texto: value.tipo === 'texto', imagen: value.tipo === 'imagen', icono: value.tipo === 'ícono', ...value.clases}" :style="value.estilos">
		<div v-if="value.tipo === 'imagen'">
			<div v-if="value.ubicación" class="contenedor-objetos">
				<figure>
					<img :src="value.ubicación">
				</figure>
				<div class="telon text-center">
					<v-btn fab @click.stop="verMedio(value)">
						<v-icon dark>mdi-pencil</v-icon>
					</v-btn>
				</div>
			</div>
			<div v-else class="medio-vacio">
				<v-btn fab @click.stop="verMedio(value)" title="Agregar imagen">
					<v-icon dark>mdi-plus</v-icon>
				</v-btn>
			</div>
		</div>
		<ParteIcono
			v-else-if="value.tipo === 'ícono'"
			v-model="value"
		></ParteIcono>
		<ParteMapa
			v-else-if="value.tipo === 'mapa'"
			v-model="value.mapa"
		></ParteMapa>
		<ParteFormulario
			v-else-if="value.tipo === 'formulario'"
			v-model="value.formulario"
		></ParteFormulario>
		<div v-else-if="value.tipo === 'texto'">
			<ParteTexto
				v-model="value.texto"
				@alinear="alinearTexto"
			></ParteTexto>
		</div>
		<div v-else-if="value.tipo === 'separador'">
			<hr>
		</div>
		<div v-else>
			[error] # {{ value.tipo }}
		</div>

		<v-dialog
      v-model="medio.ver"
      max-width="800"
    >
      <seleccionar-medio v-model="medio.parte" @hecho="medio.ver = false"></seleccionar-medio>
    </v-dialog>

	</div>
</template>

<script>

import ParteTexto from '@/components/constructor/Sitio/Pagina/Seccion/Columna/Parte/ParteTexto'
import SeleccionarMedio from '@/components/utilidades/SeleccionarMedio'
import ParteFormulario from '@/components/constructor/Sitio/Pagina/Seccion/Columna/Parte/ParteFormulario'
import ParteMapa from '@/components/constructor/Sitio/Pagina/Seccion/Columna/Parte/ParteMapa'
import ParteIcono from '@/components/constructor/Sitio/Pagina/Seccion/Columna/Parte/ParteIcono.vue'

export default {
  name: 'Parte',

  data: () => ({
    editorData: '',

		medio: {
			parte: {},
			ver: false,
		},

		espaciado: {
			ver: false,
			interno: false,
			externo: false
		},

	}),

	components: {
		ParteTexto,
		SeleccionarMedio,
		ParteFormulario,
		ParteMapa,
		ParteIcono
	},
	
	props: {
		value: {
			type: Object,
			default: function() {
				return { tipo: '', texto: '', ubicación: '', icono: { estilo: '', identificador: '' }, clases: {}, estilos: {} }
			}
		},
	},

	watch: {
		'value.ubicación': function(v) {
			if (v) {
				this.medio.ver = false
			}
		}
	},

	methods: {
		verMedio(parte) {
			this.medio.parte = parte
			this.medio.ver = true
		},
		alinearTexto: function(a) {
			this.$set(this.value.estilos, 'text-align', a)
		},
	}
};

</script>

<style>

/** PENDIENTE: estos estilos deben ir globales */

.medio-vacio {
	display: flex;
	border: 2px dashed silver;
	background-color: #eee;
	height: 8cm;
	align-items: center;
	justify-content: center;
}

.medio-vacio > div {
	flex-basis: 0;
	flex-grow: 1;
}

.contenedor-objetos {
	position: relative;
}

.contenedor-objetos > .telon {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.telon:hover {
	background-color: rgba(0,0,0,0.6);
}

</style>